/**
 * Display formatting for the users-admin screens.
 *
 * NOT imported from `features/inquiries/format.ts`, although that file has a
 * near-twin of `formatDateTime`: features do not import from each other's
 * folders in this app (each has one owning stream; the shared surface is
 * `lib/` and `components/ui`). Two small formatters are cheaper than a
 * cross-stream dependency.
 */

/** What an absent value renders as. An em dash, never a blank cell. */
export const NO_VALUE = '—';

/**
 * "23 Jul 2026, 14:05" — for `last_login_at`. Date AND time, unlike the
 * pipeline's date cells: "when did this person last sign in" is a security
 * question, and on the day you are asking it the hour is the answer.
 */
export function formatDateTime(iso: string | null | undefined): string {
  if (iso === null || iso === undefined || iso === '') return NO_VALUE;
  const date = new Date(iso);
  if (!Number.isFinite(date.getTime())) return NO_VALUE;
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}

/** `last_login_at` is NULL until the first login — say "Never", not a dash. */
export function formatLastSignIn(iso: string | null | undefined): string {
  if (iso === null || iso === undefined || iso === '') return 'Never';
  return formatDateTime(iso);
}
